import { SUPPRESSION_TIMESTAMP_SETTINGS } from '@kentik/ui-shared/alerting/constants';

export const SUPPRESSION_LIFECYCLE_STATUS = {
  PLANNED: 'planned',
  ONGOING: 'ongoing',
  EXPIRED: 'expired'
} as const;

export type SuppressionLifecycleStatus =
  (typeof SUPPRESSION_LIFECYCLE_STATUS)[keyof typeof SUPPRESSION_LIFECYCLE_STATUS];

/**
 * What the UI displays: the lifecycle, unless unresolvable references invalidate the scope.
 * Invalid is not a lifecycle state, so it exists only here and never in getSuppressionLifecycleStatus.
 */
export const SUPPRESSION_STATUS = {
  ...SUPPRESSION_LIFECYCLE_STATUS,
  INVALID: 'invalid'
} as const;

export type SuppressionStatus = (typeof SUPPRESSION_STATUS)[keyof typeof SUPPRESSION_STATUS];

export const SUPPRESSION_STATUS_LABELS: Record<SuppressionStatus, string> = {
  [SUPPRESSION_STATUS.PLANNED]: 'Planned',
  [SUPPRESSION_STATUS.ONGOING]: 'Ongoing',
  [SUPPRESSION_STATUS.EXPIRED]: 'Expired',
  [SUPPRESSION_STATUS.INVALID]: 'Invalid'
};

export function isManuallyStopped(end_time_code?: string): boolean {
  return end_time_code === SUPPRESSION_TIMESTAMP_SETTINGS.AS_SOON_AS_POSSIBLE;
}

export function getSuppressionLifecycleStatus(
  {
    start_time,
    end_time,
    end_time_code
  }: {
    start_time?: string | null;
    end_time?: string | null;
    end_time_code?: string;
  },
  now = Date.now()
): SuppressionLifecycleStatus {
  if (isManuallyStopped(end_time_code)) {
    return SUPPRESSION_LIFECYCLE_STATUS.EXPIRED;
  }

  if (end_time && new Date(end_time).getTime() <= now) {
    return SUPPRESSION_LIFECYCLE_STATUS.EXPIRED;
  }

  if (start_time && new Date(start_time).getTime() > now) {
    return SUPPRESSION_LIFECYCLE_STATUS.PLANNED;
  }

  return SUPPRESSION_LIFECYCLE_STATUS.ONGOING;
}
